export default (): any => {
  const sel = document.getSelection();
  if (!sel) return null;
  const { focusNode, focusOffset } = sel;
  if (!focusNode) return null;
  const parent = focusNode.nodeType === Node.TEXT_NODE ? focusNode.parentElement : focusNode;
  return { parent: parent as HTMLElement, focusOffset };
};
